export default __webpack_public_path__ + "static/demande.couture-800be7aaf14ba023e6a1c2f382acf35c.jpg";